import React from "react";
import "./GlobalMetricCards.css";

const DEFAULT_BARS = [0.38, 0.62, 0.45, 0.78, 0.52];
const INDIAN_NUMBER_FORMATTER = new Intl.NumberFormat("en-IN", {
  maximumFractionDigits: 0,
});

function formatMetricValue(value) {
  if (value == null || value === "") return 0;
  if (typeof value === "number" && Number.isFinite(value)) {
    return INDIAN_NUMBER_FORMATTER.format(Math.round(value));
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return 0;
    const isRupee = trimmed.startsWith("₹");
    const numericCandidate = (isRupee ? trimmed.slice(1) : trimmed).replace(/,/g, "").trim();
    if (/^-?\d+(\.\d+)?$/.test(numericCandidate)) {
      const n = Number(numericCandidate);
      if (Number.isFinite(n)) {
        const formatted = INDIAN_NUMBER_FORMATTER.format(Math.round(n));
        return isRupee ? `₹${formatted}` : formatted;
      }
    }
    return value;
  }
  return value;
}

function MetricBars({ heights = DEFAULT_BARS }) {
  return (
    <svg
      className="gm-metric-card__chart"
      viewBox="0 0 56 32"
      aria-hidden="true"
    >
      {heights.map((h, i) => (
        <rect
          key={i}
          x={4 + i * 10.5}
          y={32 - h * 26}
          width="8"
          height={h * 26}
          rx="2"
        />
      ))}
    </svg>
  );
}

export function GlobalMetricCard({ value, label, tone, chartHeights }) {
  const displayValue = formatMetricValue(value);
  return (
    <article
      className={`gm-metric-card gm-metric-card--${tone}`}
      aria-label={`${label}: ${displayValue}`}
    >
      <MetricBars heights={chartHeights} />
      <p className="gm-metric-card__value">{displayValue}</p>
      <p className="gm-metric-card__label">{label}</p>
    </article>
  );
}

export default function GlobalMetricCards({
  items,
  loading,
  skeletonCount = 4,
  ariaLabel = "Metrics",
  gridClassName = "",
}) {
  const gridBase = ["gm-metrics-grid", gridClassName].filter(Boolean).join(" ");
  if (loading) {
    return (
      <div
        className={`${gridBase} gm-metrics-grid--loading`.trim()}
        aria-busy="true"
        aria-live="polite"
      >
        {[...Array(skeletonCount)].map((_, i) => (
          <div key={i} className="gm-skeleton-card" aria-hidden="true" />
        ))}
        <p className="gm-metrics-loading">Loading snapshot…</p>
      </div>
    );
  }

  return (
    <div className={gridBase} aria-label={ariaLabel}>
      {(items || []).map((it) => (
        <GlobalMetricCard
          key={it.key || it.label}
          value={it.value}
          label={it.label}
          tone={it.tone}
          chartHeights={it.chartHeights}
        />
      ))}
    </div>
  );
}

